import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function ArticleSection() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            In-Depth Sugargoo Spreadsheet Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dive deeper with our comprehensive articles covering everything you need to know about Sugargoo Spreadsheet shopping — from beginner tutorials to advanced strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group flex flex-col bg-background-100 rounded-lg overflow-hidden hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    Read Article
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse All Spreadsheet Finds
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}